// extracted by mini-css-extract-plugin
export default {"cls1":"KErAGzg6pqE9S85sLWqg","cls2":"N_4xM6w_bPG9JTnbSHCu KErAGzg6pqE9S85sLWqg","isTabletDown":"KkgEQG6wK1xbLwgkxsYI"};